<template>
  <div class="header">
    <nav
      class="navbar navbar-expand-lg container-fluid p-md-1 p-0"
      :class="[
        show ? 'navbar-dark' : 'navbar-transparent',
        isScrolled ? 'navbar-scrolled' : '',
      ]"
      :style="this.$route.name === 'lp-content' ? 'position: fixed' : ''"
    >
      <router-link class="navbar-brand" :to="$t('routes.home')">
        <flix-latino-logo></flix-latino-logo>
      </router-link>

      <div
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <router-link
          v-if="!isLogged"
          class="logoutbutton mr-3"
          :to="$t('routes.login')"
          @click.stop="onLoginClick"
        >
          {{ $t("navbar.login") }}
        </router-link>
        <icon-menu @click="toggleMenu()"></icon-menu>
      </div>

      <div
        v-bind:class="{ show: show }"
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto tex">
          <li class="nav-item active tex">
            <router-link
              class="nav-link"
              :to="liveRoute"
              @click.stop="hideMenu()"
            >
              {{ $t("navbar.logged.live") }}
            </router-link>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="$t('routes.login')"
                @click.stop="onLoginClick"
            >
              {{ $t("navbar.login") }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="!isLogged"
              class="btn btn-light"
              :to="$t('routes.register')"
              @click.stop="hideMenu()"
            >
              <span v-if="this.$route.name !== 'lp-content'">{{
                $t("navbar.subscribe")
              }}</span>
              <span v-else>{{ $t("discover.start_now") }}</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isLogged">
            <switch-language-component
              v-if="!isLogged"
              :small="true"
              class="w-100"
            />
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import FlixLatinoLogo from "../icons/flixLatinoLogo.vue";
import { mapState } from "pinia";
import { UserStore } from "@/stores/userStore";
import IconMenu from "@/components/icons/iconMenu.vue";
import SwitchLanguageComponent from "@/components/forms/SwitchLanguageComponent.vue";
import LogoF from "@/components/icons/LogoF.vue";

export default {
  name: "transparent-header",
  components: {
    SwitchLanguageComponent,
    IconMenu,
    FlixLatinoLogo,
  },
  data() {
    return {
      show: false,
      isScrolled: false,
      navbarFixed: false,
    };
  },
  computed: {
    ...mapState(UserStore, ["getToken", "getLanguage"]),
    isLogged() {
      return this.getToken !== null && this.getToken !== "";
    },
    liveRoute() {
      return {
        name: "live",
        params: { locale: this.$route.params.locale || this.getLanguage || "es" },
      };
    },
  },
  methods: {
    onLoginClick() {
      this.hideMenu();
      this.$bus.emit("reloading", true);
    },
    hideMenu() {
      this.show = false;
    },
    toggleMenu() {
      this.show = !this.show;
    },
    handleScroll() {
      this.isScrolled =
        window.scrollY > 10 && this.$route.name === "lp-content";
    },
  },
  beforeMount() {
    this.navbarFixed = this.$route.name === "lp-content";
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";

.header {
  height: 0;
  position: relative;
  z-index: 200;
  padding-left: 50px;
  padding-right: 50px;

  .nav.navbar-fixed-top {
    position: fixed !important;
  }

  nav.navbar {
    //position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 2.35em;
    transition: background-color 0.3s ease;

    &.navbar-transparent {
      background-color: transparent;
    }

    &.navbar-dark,
    &.navbar-scrolled {
      background-color: rgba(0, 0, 0, 0.85); // customize if needed
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    .navbar-toggler {
      border: none;
      outline: none;

      .logoutbutton {
        color: #ffffff;
        font-size: 0.7em;
      }
    }

    li.nav-item {
      margin: 0 0.5em;
    }
  }

  @media (max-width: 767px) {
    padding-right: 16px;
    padding-left: 16px;
    nav {
      padding: 1em;
    }

    #navbarSupportedContent {
      backdrop-filter: blur(10px);
      position: fixed;
      top: 4em;
      width: 100%;
      height: 100%;
      left: 0;
      padding: 1em 2em;
      z-index: 99;

      .nav-item {
        text-align: center;
        font-size: 1.5em;
        padding: 0.3em;

        &:active {
          a {
            border-radius: 0.5em;
            background-color: $washed-white;
          }
        }
      }
    }
  }
}
</style>
